import { Component, OnInit, ViewChild, Directive, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { SessionStorageService } from 'ngx-webstorage';
import { ConstantService } from '../../../components/common/utils/constant.service';
import { ArchivoDocumentoAsitenciaMedica, DocumentosActualizar, SiniestroTracking } from '../siniestros_entity';
const swal = require("sweetalert2");
declare var jQuery: any;
@Component({
    selector: "trackingVivienda",
    templateUrl: 'tracking-siniestros-vivienda.template.html',
    styleUrls: ["tracking-siniestros-vivienda.styles.css"]
})

export class TrackingViviendaComponent implements OnInit, OnChanges {
    reporteRecibido: boolean;
    documentacion: boolean;
    inspeccion: boolean;
    autorizacionReparacion: boolean;
    reparacion: boolean;
    cierre: boolean;

    link_reporteRecibido: boolean;
    link_documentacion: boolean;
    link_inspeccion: boolean;
    link_autorizacionReparacion: boolean;
    link_reparacion: boolean;
    link_cierre: boolean;

    @Input()
    trackingVivienda: SiniestroTracking;

    resultadoTracking: SiniestroTracking;
    docsCliente: ArchivoDocumentoAsitenciaMedica[] = new Array<ArchivoDocumentoAsitenciaMedica>();
    devolverMensaje: any;
    showLoader: string = "";
    formData: FormData = new FormData();
    files: File[] = [];
    url: string = "utils";
    docsActualizar: DocumentosActualizar = new DocumentosActualizar();
    current: number;

    constructor(public sesionStorageService: SessionStorageService) {
        this.reporteRecibido = false;
        this.documentacion = false;
        this.inspeccion = false;
        this.autorizacionReparacion = false;
        this.reparacion = false;
        this.cierre = false;

        this.link_reporteRecibido = false;
        this.link_documentacion = false;
        this.link_inspeccion = false;
        this.link_autorizacionReparacion = false;
        this.link_reparacion = false;
        this.link_cierre = false;
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;

        this.resultadoTracking = new SiniestroTracking();

        this.devolverMensaje = (parametro: number, documento: any): void => {
          if (parametro == 200) {
            let rcl = JSON.parse(documento);
            swal({
              title: 'Actualizar Documentación',
              text: "Su información ha sido enviada satisfactoriamente",
              type: 'success'
            }).then(()=>{
              window.location.reload();
            });

            this.docsCliente = new Array<ArchivoDocumentoAsitenciaMedica>();
            this.showLoader = "";
            this.formData = new FormData();
          }
          else {
            swal({
              title: 'Actualizar Documentación',
              text: "Existio un error, por favor intentelo más tarde, lamentamos el inconveniente.",
              type: 'error'
            });
            this.showLoader = "";
            this.formData = new FormData();
          }
        }
    }

    ngOnInit(){
        this.resultadoTracking = this.trackingVivienda;
        if(this.resultadoTracking.DetalleSiniestro != null){
            this.reporteRecibido = true;
            this.documentacion = false;
            this.inspeccion = false;
            this.autorizacionReparacion = false;
            this.cierre = false;
            this.link_reporteRecibido = true;
        }else{
            this.link_reporteRecibido = false;
        }
        if(this.resultadoTracking.Documentacion != null){
            this.reporteRecibido = false;
            this.documentacion = true;
            this.inspeccion = false;
            this.autorizacionReparacion = false;
            this.reparacion = false;
            this.cierre = false;
            this.link_documentacion = true;
        }else{
            this.link_documentacion = false;
        }
        if(this.resultadoTracking.Inspeccion != null && this.resultadoTracking.Documentacion.documentosFaltantes.length==0){
            this.reporteRecibido = false;
            this.documentacion = false;
            this.inspeccion = true;
            this.autorizacionReparacion = false;
            this.reparacion = false;
            this.cierre = false;
            this.link_inspeccion = true;
        }else{
            this.link_inspeccion = false;
        }
        if(this.resultadoTracking.Cobertura != null){
            this.reporteRecibido = false;
            this.documentacion = false;
            this.inspeccion = false;
            this.autorizacionReparacion = true;
            this.reparacion = false;
            this.cierre = false;
            this.link_autorizacionReparacion = true;
        }else{
            this.link_autorizacionReparacion = false;
        }
        if(this.resultadoTracking.Liquidacion != null){
            this.reporteRecibido = false;
            this.documentacion = false;
            this.inspeccion = false;
            this.autorizacionReparacion = false;
            this.reparacion = false;
            this.cierre = true;
            this.link_cierre = true;
        }else{
            this.link_cierre = false;
        }
    }
    ngOnChanges(){
        this.resultadoTracking = this.trackingVivienda;
        if(this.resultadoTracking.DetalleSiniestro != null){
            this.reporteRecibido = true;
            this.documentacion = false;
            this.inspeccion = false;
            this.autorizacionReparacion = false;
            this.reparacion = false;
            this.cierre = false;
            this.link_reporteRecibido = true;
        }else {
            this.link_reporteRecibido = false;
        }
        if(this.resultadoTracking.Documentacion != null){
            this.reporteRecibido = false;
            this.documentacion = true;
            this.inspeccion = false;
            this.autorizacionReparacion = false;
            this.reparacion = false;
            this.cierre = false;
            this.link_documentacion = true;
        }else {
            this.link_documentacion = false;
        }
        if(this.resultadoTracking.Inspeccion != null){
            this.reporteRecibido = false;
            this.documentacion = false;
            this.inspeccion = true;
            this.autorizacionReparacion = false;
            this.reparacion = false;
            this.cierre = false;
            this.link_inspeccion = true;
        }else {
            this.link_inspeccion = false;
        }
        if(this.resultadoTracking.Liquidacion != null){
            this.reporteRecibido = false;
            this.documentacion = false;
            this.inspeccion = false;
            this.autorizacionReparacion = false;
            this.reparacion = false;
            this.cierre = true;
            this.link_cierre = true;
        }else {
            this.link_cierre = false;
        }
    }

    accion(paso: number) {
        switch (paso) {
            case 1:
                this.reporteRecibido = true;
                this.documentacion = false;
                this.inspeccion = false;
                this.autorizacionReparacion = false;
                this.cierre = false;
                break;
            case 2:
                this.reporteRecibido = false;
                this.documentacion = true;
                this.inspeccion = false;
                this.autorizacionReparacion = false;
                this.cierre = false;
                break;
            case 3:
                this.reporteRecibido = false;
                this.documentacion = false;
                this.inspeccion = true;
                this.autorizacionReparacion = false;
                this.cierre = false;
                break;
            case 4:
                this.reporteRecibido = false;
                this.documentacion = false;
                this.inspeccion = false;
                this.autorizacionReparacion = true;
                this.cierre = false;
                break;
            case 5:
                this.reporteRecibido = false;
                this.documentacion = false;
                this.inspeccion = false;
                this.autorizacionReparacion = false;
                this.reparacion = true;
                this.cierre = false;
                break;
            case 6:
                this.reporteRecibido = false;
                this.documentacion = false;
                this.inspeccion = false;
                this.autorizacionReparacion = false;
                this.cierre = true;
                break;
        }
    }

    CrearDocumento(document: ArchivoDocumentoAsitenciaMedica) {
      let a = this.docsCliente.length;
      let codigo = 1;

      codigo =
        Math.max.apply(
          Math,
          this.docsCliente.map(function (o) {
            return o.IdDocumento;
          })
        ) + 1;
      if (!isFinite(codigo)) {
        codigo = 1;
      }

      let doc = new ArchivoDocumentoAsitenciaMedica();
      doc.TipoDocumento = document.TipoDocumento;
      doc.IdDocumento = codigo;
      doc.IdSiniestro=document.IdSiniestro;
      this.docsCliente.push(doc);
    }

    fileChange(archivo: any, doc: ArchivoDocumentoAsitenciaMedica) {
      let archivoEncontrado = undefined;
      if (this.files != undefined) {
        archivoEncontrado = this.files.filter(a => a.name == archivo.target.files[0].name);
      }
      if (archivoEncontrado != null && archivoEncontrado != undefined && archivoEncontrado.length > 0) {
        swal({
          title: 'Archivo ',
          text: "El nombre de archivo ya existe, por favor modifique su nombre",
          type: 'error'
        });
      } else {
        doc.Descripcion = archivo.target.files[0].name;
        doc.TipoMIME = archivo.target.files[0].type;
        this.files.push(archivo.target.files[0]);
      }
    }
    eliminarArchivo(doc: ArchivoDocumentoAsitenciaMedica) {
      this.docsCliente = JSON.parse(
        JSON.stringify(
          this.docsCliente.filter((a) => a.IdDocumento != doc.IdDocumento)
        )
      );
      this.files = this.files.filter((a) => a.name != doc.Descripcion);

    }

    EnviarDocumentos() {
      this.showLoader = "sk-loading";
      this.docsActualizar.MedioReporte = 1909;
      this.docsActualizar.DocumentosReclamo = JSON.parse(
        JSON.stringify(this.docsCliente)
      );
      this.files.forEach((a) => {
        this.formData.append(a.name, a, a.name);
      });

      this.formData.append("Siniestro", JSON.stringify(this.docsActualizar));

      const xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          this.devolverMensaje(xhr.status, xhr.response);
        }
      }.bind(this);
      xhr.open("post", this.url + "/GetActualizarDocsSiniestro", true);
      xhr.setRequestHeader("enctype", "multipart/form-data");
      // IE workaround for Cache issues
      xhr.setRequestHeader("Cache-Control", "no-cache");
      xhr.setRequestHeader("Cache-Control", "no-store");
      xhr.setRequestHeader("Pragma", "no-cache");
      xhr.setRequestHeader(
        "Authorization",
        "Token " + this.sesionStorageService.retrieve("Token")
      );
      xhr.setRequestHeader("Reclamos", JSON.stringify(this.docsActualizar));

      xhr.send(this.formData);
    }


}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/siniestros/tracking/tracking-siniestros-vivienda.component.ts